import { cn } from "~/utils/fontsConfig";
import { SmallRiverLoading } from "./RiverLoading";

type SpinnerProps = {
    className?: React.HTMLAttributes<HTMLDivElement>["className"];
    type?: "small" | "medium" | "large";
    center?: boolean;
};

export const SpinnerV1 = ({ className, type, center }: SpinnerProps) => {
    const size =
        type === "small"
            ? "h-4 w-4"
            : type === "medium"
              ? "h-6 w-6"
              : "h-10 w-10";

    if (center) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <span
                    className={cn(
                        `
                        inline-block 
                        animate-spin 
                        rounded-full border-4
                        border-solid 
                        border-current 
                        border-r-transparent 
                        align-[-0.125em] 
                        text-backgroundInvert 
                        motion-reduce:animate-[spin_1.5s_linear_infinite]
                        `,
                        size,
                        className,
                    )}
                    role="status"
                />
            </div>
        );
    }

    return (
        <span
            className={cn(
                `
                inline-block 
                animate-spin 
                rounded-full border-4
                border-solid 
                border-current 
                border-r-transparent 
                align-[-0.125em] 
                text-backgroundInvert 
                motion-reduce:animate-[spin_1.5s_linear_infinite]
                `,
                size,
                className,
            )}
            role="status"
        />
    );
};

// lets return the new SmallRiverLoading here, but you can also pass the size
const Spinner = ({ className, type, center }: SpinnerProps) => {
    let width = 10;
    let height = 30;

    if (type === "small") {
        width = 7;
        height = 20;
    } else if (type === "large") {
        width = 15;
        height = 50;
    }

    return <SmallRiverLoading height={height} width={width} />;
};

export default Spinner;
